/**
 * Plugin JQuery permettant le chargement/traitement des fenêtres modales.
 *
 * @author Zébina Samuel <samuel.zebina@education.gouv.fr>
 * @version 1.0
 */
(function(factory) {
    if(typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('dgrhMdLink', ['jQuery', 'jQueryUi'], factory);
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function($) {
    $.widget( "dgrh.mdLink" , {

        options: {
            ajaxLoaderCls:              'ajaxLoader',
            ajaxOkCls:                  'ajaxOk',
            waitingCls:                 'waitingModalBox',
            modalBoxLinkCls:            'linkModalBox',
            modalBoxId:                 'modalBox',
            cancelBtnId:                'cancel',
            formId:                     'modalForm',
            rurlHeaderCode:             'X-DGRH-Rurl',
            okHeaderStatusCode:         'X-DGRH-Status',
            loadingMsg:                 'Chargement en cours...',
            processingMsg:              'Traitement en cours...',
            okMsg:                      'Opération effectuée',
            processUrlCallback:         function(sUrl) { return sUrl; },
            beforeSubmitCallback:       function(oForm) {},
            extraDataCallback:          function() {return {};},
            dialogOpenCallback:         function(oEvent, oUi) { return {};},
            beforeDialogCloseCallback:  function(oEvent, oUi) { return {};}
        },

        _create: function () {
            var self    = this,
                options = this.options;

            //console.log('ui.mdLink::_create ...', $(this.element));

            $("." + options.modalBoxLinkCls, $(this.element)).click(function(event) {
                event.preventDefault();

                //console.log($(self.element));

                var oExtraData  = options.extraDataCallback(),
                    sUrl        = options.processUrlCallback($(this).attr('href')),
                    oModalBox   = $("#" + options.modalBoxId);

                oModalBox.dialog({open: function(oEvent, oUi) {
                        self._initOpenedDialog(oEvent, self);
                        self.options.dialogOpenCallback(oEvent, self);
                    }, beforeClose: function(oEvent, oUi) {
                        self.options.beforeDialogCloseCallback(oEvent, self);
                        self._beforeDialogClose(oEvent, self);
                    }
                });
                self._loadModalBox(sUrl, oExtraData, oModalBox);
            });
        },

        _init: function () {
            //console.log('ui.mdLink::_init ...');
        },

        _loadModalBox: function (sUrl, oExtraData, oModalBox) { 
            var self = this;

            $.ajax({
                type        : "GET",
                url         : sUrl,
                dataType    : "html",
                data        : oExtraData,
                async       : true,
                beforeSend  : function(oXhr, oSettings) {
                    //console.log('Before send ...');
                    oXhr.setRequestHeader("X-DGRH-RqType", 'DgrhMdlWnd');
                    self._openWaitingDialog(oModalBox, self.options.loadingMsg);
                },
                complete    : function(oXhr, sStatus) { //Called regardless of if the request was successful, or not
                    //console.log('Complete ...');
                    self._processXhrComplete(oModalBox, oXhr);
                }
            });
        },

        _openWaitingDialog: function (oModalBox, sText) {
oModalBox.addClass(this.options.waitingCls);
            this._openUntitledDialog(oModalBox, sText, this.options.ajaxLoaderCls);
        },

        _openUntitledDialog: function (oModalBox, sText, sClass) {
            oModalBox.dialog("close");
            $(".ui-dialog-titlebar").hide();
            oModalBox.dialog("option", 'height', 55);

            var aDatas = [ ];

            aDatas.push('<div');
            if(typeof sClass === "string") {
                aDatas.push(' class=\"');
                aDatas.push(sClass);
                aDatas.push('\"');
            }
            aDatas.push('>');
            aDatas.push('<span>');
            aDatas.push(sText);
            aDatas.push('</span></div>');

            oModalBox.html(aDatas.join('')); 
            oModalBox.dialog("open");
        },

        _processXhrComplete: function (oModalBox, oXhr) {
            //-- BEGIN EN TEST
                //Si session expiré alors redirect to login page
            var sUrl = oXhr.getResponseHeader('X-DGRH-Rurl');
            if(null !== sUrl && 0 < sUrl.length) {
                setTimeout(function() {
                    //console.log('Redirection');
                    document.location.href = sUrl;
                }, 300);
                return;
            }
            //-- END EN TEST

            var sContent    = '',
                sTitle      = '';
            if('application/json' == oXhr.getResponseHeader('Content-Type')) {
                var oJson   = $.parseJSON(oXhr.responseText);
                sContent    = oJson.sWndContent;
                sTitle      = oJson.sWndTitle;
            } else {
                sContent    = oXhr.responseText;
            }

            oModalBox.dialog("close");
            oModalBox.html(sContent);
            oModalBox.dialog("option", 'height', 'auto');
            oModalBox.dialog("option", 'title', sTitle);
            $(".ui-dialog-titlebar").show();
            oModalBox.dialog("open");
        },

        _initOpenedDialog: function (oEvent, oUi) {
            var self        = oUi,
                options     = oUi.options,
                oModalBox   = $("#" + options.modalBoxId);

            $("#" + options.cancelBtnId).on('click', function(oEvt) {
                oEvt.preventDefault();
                oModalBox.dialog("close");
            });

            $("#" + options.formId).on('submit', function submitForm(oEvt) {
                oEvt.preventDefault();
                var oForm = $(this);

                options.beforeSubmitCallback(oForm);

                $.ajax({
                    type        : "POST",
                    url         : oForm.attr('action'),
                    dataType    : "html",
                    data        : oForm.serialize(),
                    async       : true,
                    beforeSend  : function(oXhr, oSettings) {
                        //console.log('Before send ...');
                        oXhr.setRequestHeader("X-DGRH-RqType", 'DgrhMdlWnd');
                        self._openWaitingDialog(oModalBox, options.processingMsg);
                    },
                    complete    : function(oXhr, sStatus) { //Called regardless of if the request was successful, or not
                        //console.log('Complete ...');
                        var iCode = oXhr.getResponseHeader(options.okHeaderStatusCode);
                        if(200 == iCode) {
                            self._openUntitledDialog(oModalBox, options.okMsg, options.ajaxOkCls);
                            var sUrl = oXhr.getResponseHeader(options.rurlHeaderCode);
                            if(null !== sUrl && 0 < sUrl.length) {
                                setTimeout(function() {
                                    //console.log('Redirection');
                                    document.location.href = sUrl;
                                }, 300);
                            } else {
                                setTimeout(function() {
                                    //console.log('Rechargement de la page');
                                    document.location.href = document.location.href;
                                }, 300);
                            }
                            return;
                        }
                        self._processXhrComplete(oModalBox, oXhr);
                    }
                });
            });

//            if($.browser.msie && parseInt($.browser.version, 10) == 7) {
//                self._resizeTitle(oModalBox);
//            }
        },

        _beforeDialogClose: function (oEvent, oUi) {
            //console.log('_beforeDialogClose ...');

            var options = oUi.options;

            $(".ui-dialog-titlebar").hide();
            $("#" + options.cancelBtnId).off('click');
            $("#" + options.formId).off('submit');
$("#" + options.modalBoxId).removeClass(options.waitingCls);
        },

        _resizeTitle: function (oModalBox) {
            if(!oModalBox.hasClass('waitingModalBox')) {
                //Quand on est en ie7 c'est gros et moche.
                oModalBox.dialog('option', {'width':900});
            }
        }

        /*
        // Respond to any changes the user makes to the 
        // option method
        _setOption: function ( key, value ) {
            switch (key) {
            case "someValue":
                //this.options.someValue = doSomethingWith( value );
                break;
            default:
                //this.options[ key ] = value;
                break;
            }

            // For UI 1.8, _setOption must be manually invoked 
            // from the base widget
            //$.Widget.prototype._setOption.apply( this, arguments );
            // For UI 1.9 the _super method can be used instead
            this._super( "_setOption", key, value );
        }
        //*/
    });
}));
